var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.61724 4.12808C1.22349 4.22651 0.928174 4.39526 0.628174 4.69526C0.323486 4.99995 0.135986 5.33276 0.0516113 5.74058C-0.0233887 6.09683 -0.0233887 18.9125 0.0516113 19.2593C0.225049 20.0609 0.881299 20.7171 1.67817 20.8859C2.02974 20.9609 21.9704 20.9609 22.3219 20.8859C23.1188 20.7171 23.7797 20.0515 23.9485 19.2593C24.0235 18.9031 24.0235 6.08745 23.9485 5.74058C23.775 4.93433 23.1235 4.28276 22.3219 4.11401C21.9422 4.03433 1.93599 4.04839 1.61724 4.12808ZM17.0391 10.0203C14.536 12.5187 12.436 14.6 12.3657 14.6375C12.2016 14.7218 11.7985 14.7218 11.6344 14.6375C11.5641 14.6 9.46411 12.5187 6.96099 10.0203L2.41411 5.4687H12H21.586L17.0391 10.0203ZM4.43911 15.5328L1.4063 18.5703V12.5V6.42964L4.43911 9.46714L7.47661 12.5L4.43911 15.5328ZM22.5938 12.5093V18.5703L19.561 15.5375L16.5235 12.5L19.5469 9.47651C21.211 7.81245 22.575 6.45308 22.5797 6.45308C22.5891 6.45308 22.5938 9.1812 22.5938 12.5093ZM9.55786 14.6234C10.5657 15.6218 10.6969 15.7343 11.0344 15.9031L11.4094 16.0859H11.9954C12.5813 16.0859 12.5907 16.0859 12.9563 15.9078C13.2985 15.7437 13.4063 15.65 14.4469 14.6234L15.5672 13.5125L18.5766 16.5218L21.586 19.5312H12H2.41411L5.41411 16.5312C7.06411 14.8812 8.42349 13.5312 8.43286 13.5312C8.44692 13.5312 8.95317 14.0234 9.55786 14.6234Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEMail);
export default __webpack_public_path__ + "static/media/e-mail.1da52e017f7eb977638d4c53df3517d8.svg";
export { ForwardRef as ReactComponent };